export const getUrl = () => {
    // return "http://127.0.0.1:5000";
    return "https://cors-proxy.mahmoud-m.workers.dev?url=http://rgm-env.eba-s9jtimap.eu-west-3.elasticbeanstalk.com"
  };

export const getUserDisplayName = () => {
  const manufacturer = localStorage.getItem("manufacturer");
  const name = localStorage.getItem("name");
  return manufacturer && manufacturer !== "null" && manufacturer !== "undefined" ? manufacturer : name || "";
};